export * from 'server/models/ReservationsInBatch';


// WEBPACK FOOTER //
// ./data/models/ReservationsInBatch.ts